(function () {
    const POPUP_ID = 'nvdLearnMorePopupOverlay';
    let converting = false;

    // 1. Inject instant CSS to force the original element or the dialog into the top layer immediately
    const style = document.createElement('style');
    style.textContent = `
        #${POPUP_ID} {
            position: fixed !important;
            inset: 0 !important;
            z-index: 2147483647 !important; /* Forces it over the cart drawer instantly */
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            max-width: none !important;
            max-height: none !important;
        }
    `;
    document.head.appendChild(style);

    function convertPopup(popup) {
        if (!popup || popup.tagName === 'DIALOG' || converting) return;
        converting = true;

        const dialog = document.createElement('dialog');
        dialog.id = POPUP_ID;
        dialog.className = popup.className;

        while (popup.firstChild) {
            dialog.appendChild(popup.firstChild);
        }

        popup.replaceWith(dialog);
        dialog.setAttribute('aria-modal', 'true');

        if (!dialog.open) {
            dialog.showModal();
        }

        // Use event delegation on the dialog instead of locating the button specifically
        dialog.onclick = function (event) {
            if (event.target.closest('.nvd-learnmore-popup-close')) {
                event.preventDefault();
                if (dialog.open) dialog.close();
                dialog.classList.remove('show');
            }
        };

        converting = false;
    }

    // 2. High-performance observer tailored specifically to attribute modifications
    const observer = new MutationObserver(function (mutations) {
        if (converting) return;

        const popup = document.getElementById(POPUP_ID);
        if (!popup) return;

        const hasShowClass = popup.classList.contains('show');

        if (popup.tagName === 'DIALOG') {
            if (hasShowClass && !popup.open) {
                popup.showModal();
            } else if (!hasShowClass && popup.open) {
                popup.close(); // Cleanly close it if Navidium removes the .show class
            }
            return;
        }

        if (hasShowClass) {
            convertPopup(popup);
        }
    });

    // 3. Only watch for attribute (class) changes and target child insertions, skipping heavy subtree text/node monitoring
    observer.observe(document.body, {
        childList: true,
        attributes: true,
        attributeFilter: ['class'],
        subtree: true,
    });

    // Run an initial check in case it's already there
    const initialPopup = document.getElementById(POPUP_ID);
    if (initialPopup && initialPopup.classList.contains('show')) {
        convertPopup(initialPopup);
    }
})();
